<template>
  <section class="dp-layout cgc-admin">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" pane-title="家校通讯录" @tree-node-click="treeNodeClick" />
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="竞赛小组">
              <el-input v-model="filters.name" clearable placeholder="支持模糊" class="toolbar-field-w-md" />
            </el-form-item>
            <el-form-item label="周期">
              <el-select v-model="filters.periodType" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="按周" value="Week" />
                <el-option label="按月" value="Month" />
                <el-option label="指定日期" value="DateRange" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button size="small" icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" :disabled="!departmentId" @click="openCompetition()">新增</el-button>
            <el-button size="small" type="warning" icon="el-icon-download" :loading="exporting" @click="exportExcel">导出</el-button>
          </div>
        </el-form>
      </div>

      <div class="tbl-scroll-host">
        <el-table :data="competitions" v-loading="loading" border height="100%">
          <el-table-column prop="DepartmentName" label="班级" min-width="140" show-overflow-tooltip fixed="left" />
          <el-table-column prop="Name" label="竞赛小组" min-width="160" show-overflow-tooltip />
          <el-table-column label="周期" min-width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag size="mini" effect="plain" :type="periodTagType(row.PeriodType)">
                {{ periodLabel(row.PeriodType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="竞赛时间" min-width="200" align="center">
            <template slot-scope="{ row }">{{ formatDate(row.StartDate) }} 至 {{ formatDate(row.EndDate) }}</template>
          </el-table-column>
          <el-table-column label="成员数" min-width="100" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" class="table-op-link" @click="openMembers(row)">{{ row.MemberCount || 0 }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="160" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" class="table-op-link" @click="openCompetition(row)">编辑</el-button>
              <el-button type="text" class="table-op-link table-op-link--danger" @click="removeCompetition(row)">停用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="pagination.total"
          :current-page.sync="pagination.page"
          :page-size.sync="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>

      <el-dialog :title="competitionForm.Id ? '编辑竞赛小组' : '新增竞赛小组'" :visible.sync="competitionDialog" width="620px">
        <el-form :model="competitionForm" label-width="100px">
          <el-form-item v-if="competitionForm.Id || isClassNode" label="班级">
            <el-input :value="fixedClassLabel" disabled />
          </el-form-item>
          <el-form-item v-else label="所属班级" required>
            <el-cascader
              v-model="classPath"
              :options="classCascaderOptions"
              :props="classCascaderProps"
              filterable
              clearable
              :placeholder="classCascaderPlaceholder"
              style="width: 100%"
              @change="onClassPathChange"
            />
          </el-form-item>
          <el-form-item label="竞赛小组" required>
            <el-input v-model="competitionForm.Name" placeholder="例如：第一竞赛小组" />
          </el-form-item>
          <el-form-item label="周期类型">
            <el-select v-model="competitionForm.PeriodType" style="width: 100%" @change="onPeriodTypeChange">
              <el-option label="按周" value="Week" />
              <el-option label="按月" value="Month" />
              <el-option label="指定日期" value="DateRange" />
            </el-select>
          </el-form-item>
          <template v-if="competitionForm.PeriodType === 'Month'">
            <el-form-item label="开始月份" required>
              <el-date-picker
                v-model="startMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="开始月份"
                style="width: 100%"
                @change="syncMonthFormDates"
              />
            </el-form-item>
            <el-form-item label="结束月份" required>
              <el-date-picker
                v-model="endMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="结束月份"
                style="width: 100%"
                @change="syncMonthFormDates"
              />
              <div class="field-tip field-tip--month">
                <div>
                  排行按<span class="tip-em tip-em--primary">自然月</span>切分：
                  <span class="tip-em tip-em--success">月初</span>
                  至
                  <span class="tip-em tip-em--warning">月末</span>
                  为一期。
                </div>
                <div>
                  首尾不足整月按<span class="tip-em tip-em--warning">实际天数</span>计，并在排行中标注。
                </div>
                <div>
                  上一月在<span class="tip-em tip-em--danger">下月 1 日凌晨</span>固化快照；
                  到<span class="tip-em tip-em--danger">结束月份</span>过后竞赛停止，不再开新月。
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="开始日期" required>
              <el-date-picker
                v-model="competitionForm.StartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="结束日期" required>
              <el-date-picker
                v-model="competitionForm.EndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                style="width: 100%"
              />
              <div v-if="competitionForm.PeriodType === 'Week'" class="field-tip field-tip--week">
                <div>
                  排行按<span class="tip-em tip-em--primary">自然周</span>切分：
                  <span class="tip-em tip-em--success">周一 00:00</span>
                  至
                  <span class="tip-em tip-em--warning">周日 24:00</span>
                  为一周。
                </div>
                <div>
                  起止日期可任意选；首尾不足一周按<span class="tip-em tip-em--warning">实际天数</span>计，并在排行中标注。
                </div>
                <div>
                  上一周在<span class="tip-em tip-em--danger">下周一凌晨</span>固化快照；
                  到<span class="tip-em tip-em--danger">结束日期</span>后竞赛停止，不再开新周。
                </div>
              </div>
              <div v-else class="field-tip field-tip--date">
                <div>
                  <span class="tip-em tip-em--primary">开始日期</span>
                  至
                  <span class="tip-em tip-em--warning">结束日期</span>
                  为唯一计分周期，不再按周或按月切分。
                </div>
                <div>
                  结束日期当天的评价仍计入；结束后由
                  <span class="tip-em tip-em--danger">每日凌晨任务</span>
                  固化快照。
                </div>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="说明"><el-input type="textarea" v-model="competitionForm.Description" /></el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="competitionDialog = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="saveCompetition">保存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="memberDialogTitle"
        :visible.sync="memberDialog"
        width="860px"
        custom-class="cgc-member-dialog"
        append-to-body
      >
        <div class="member-meta">
          <span>班级：{{ memberForm.DepartmentName || '-' }}</span>
          <span>竞赛小组：{{ memberForm.Name || '-' }}</span>
          <span>已选 {{ memberStudentIds.length }} / {{ students.length }} 人</span>
        </div>
        <div class="member-toolbar">
          <el-input
            v-model="memberKeyword"
            clearable
            size="small"
            placeholder="搜索姓名 / 号次 / 学号 / 卡号"
            prefix-icon="el-icon-search"
            class="member-toolbar__search"
          />
          <div class="member-toolbar__actions">
            <el-button size="small" @click="selectAllMembers">全选当前</el-button>
            <el-button size="small" @click="clearMemberSelection">清空已选</el-button>
          </div>
        </div>
        <el-table
          :data="filteredStudents"
          v-loading="memberLoading"
          border
          height="420"
          row-key="StudentId"
          class="member-table"
          @row-click="onMemberRowClick"
        >
          <el-table-column width="52" align="center">
            <template slot="header">
              <el-checkbox
                :value="isAllFilteredSelected"
                :indeterminate="isFilteredIndeterminate"
                @change="toggleSelectAllFiltered"
              />
            </template>
            <template slot-scope="{ row }">
              <el-checkbox
                :value="isMemberSelected(row.StudentId)"
                @change="(checked) => setMemberSelected(row.StudentId, checked)"
                @click.native.stop
              />
            </template>
          </el-table-column>
          <el-table-column prop="SeatNumber" label="号次" min-width="80" align="center">
            <template slot-scope="{ row }">{{ formatSeatNumber(row.SeatNumber) }}</template>
          </el-table-column>
          <el-table-column label="头像" min-width="80" align="center">
            <template slot-scope="{ row }">
              <oss-media-thumbs
                v-if="row.HeadPhotoImage"
                :media="row.HeadPhotoImage"
                thumb-width="40px"
                thumb-height="40px"
              />
              <span v-else class="member-avatar-empty">{{ studentNameInitial(row.StudentName) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="StudentName" label="姓名" min-width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="StuCode" label="学号" min-width="120" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.StuCode || '' }}</template>
          </el-table-column>
          <el-table-column prop="CardNumber" label="卡号" min-width="120" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.CardNumber || '' }}</template>
          </el-table-column>
        </el-table>
        <span slot="footer">
          <el-button @click="memberDialog = false">取消</el-button>
          <el-button type="primary" :loading="savingMembers" @click="saveMembers">保存</el-button>
        </span>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import {
  getClassGroupCompetitions, getClassGroupCompetitionSummary, saveClassGroupCompetition, deleteClassGroupCompetition,
  getClassGroupCompetitionTeams, getClassGroupCompetitionClassStudents, exportClassGroupCompetitions,
} from '../../api/modules/moral-education';

export default {
  name: 'ClassGroupCompetitionAdmin',
  components: { DepartmentPane },
  data() {
    return {
      departmentId: 0,
      className: '',
      treeNode: null,
      competitions: [],
      loading: false,
      exporting: false,
      saving: false,
      filters: { name: '', periodType: '' },
      pagination: { page: 1, pageSize: 20, total: 0 },
      competitionDialog: false,
      competitionForm: this.emptyCompetition(),
      memberDialog: false,
      memberForm: {},
      memberStudentIds: [],
      memberKeyword: '',
      memberLoading: false,
      savingMembers: false,
      startMonth: null,
      endMonth: null,
      classPath: [],
      classCascaderOptions: [],
      classCascaderProps: { value: 'value', label: 'label', children: 'children', emitPath: true },
      students: [],
    };
  },
  computed: {
    /**
     * 当前左侧是否选中班级节点。
     */
    isClassNode() {
      return this.getOrgType(this.treeNode) === 'class';
    },
    /**
     * 新增/编辑时展示的固定班级文案。
     */
    fixedClassLabel() {
      if (this.competitionForm.Id) {
        return this.competitionForm.DepartmentName || this.className || String(this.competitionForm.DepartmentId || '');
      }
      return this.className || '';
    },
    /**
     * 成员维护弹窗标题。
     */
    memberDialogTitle() {
      const name = this.memberForm && this.memberForm.Name;
      return name ? `维护成员 · ${name}` : '维护成员';
    },
    /**
     * 成员表格：按姓名/号次/学号/卡号过滤（列表加载时已按号次排好）。
     */
    filteredStudents() {
      const keyword = String(this.memberKeyword || '').trim().toLowerCase();
      if (!keyword) return this.students || [];
      return (this.students || []).filter((student) => {
        const name = String(student.StudentName || '').toLowerCase();
        const seat = String(student.SeatNumber == null ? '' : student.SeatNumber);
        const code = String(student.StuCode || '').toLowerCase();
        const card = String(student.CardNumber || '').toLowerCase();
        return name.includes(keyword) || seat.includes(keyword) || code.includes(keyword) || card.includes(keyword);
      });
    },
    /**
     * 当前筛选结果是否已全选。
     */
    isAllFilteredSelected() {
      const rows = this.filteredStudents || [];
      return rows.length > 0 && rows.every((row) => this.isMemberSelected(row.StudentId));
    },
    /**
     * 当前筛选结果是否部分选中。
     */
    isFilteredIndeterminate() {
      const rows = this.filteredStudents || [];
      if (!rows.length) return false;
      const selectedCount = rows.filter((row) => this.isMemberSelected(row.StudentId)).length;
      return selectedCount > 0 && selectedCount < rows.length;
    },
    /**
     * 级联选择占位提示。
     */
    classCascaderPlaceholder() {
      const type = this.getOrgType(this.treeNode);
      if (type === 'school') return '请选择校区 / 年级 / 班级';
      if (type === 'campus') return '请选择年级 / 班级';
      if (type === 'grade') return '请选择班级';
      return '请选择班级';
    },
  },
  methods: {
    emptyCompetition() {
      const week = this.getDefaultWeekRange();
      return {
        Id: 0, TeacherInfoId: 0, DepartmentId: 0, DepartmentName: '', Name: '', Description: '',
        PeriodType: 'Week', StartDate: week.StartDate, EndDate: week.EndDate, Status: 1, StudentIds: [],
      };
    },
    /**
     * 加载指定班级学生，并按号次排序。
     */
    async loadClassStudents(departmentId) {
      if (!departmentId) {
        this.students = [];
        return;
      }
      const rows = this.responseData(
        await getClassGroupCompetitionClassStudents({ departmentId })
      ) || [];
      this.students = rows
        .map((item) => ({
          StudentId: Number(item.StudentId || item.studentId || 0),
          StudentName: item.StudentName || item.studentName || '',
          SeatNumber: Number(item.SeatNumber != null ? item.SeatNumber : item.seatNumber) || 0,
          StuCode: item.StuCode || item.stuCode || '',
          CardNumber: item.CardNumber || item.cardNumber || '',
          HeadPhotoImage: item.HeadPhotoImage || item.headPhotoImage || '',
        }))
        .filter((item) => item.StudentId > 0)
        .sort((a, b) => {
          if (a.SeatNumber !== b.SeatNumber) return a.SeatNumber - b.SeatNumber;
          return a.StudentId - b.StudentId;
        });
    },
    /**
     * 加载竞赛小组成员 Id 列表。
     */
    async fetchCompetitionMemberIds(competitionId) {
      if (!competitionId) return [];
      const teams = this.responseData(await getClassGroupCompetitionTeams({ competitionId })) || [];
      const sole = teams[0];
      return sole
        ? (sole.Members || [])
          .map((x) => Number(x.StudentId || x.studentId || 0))
          .filter((id) => id > 0)
        : [];
    },
    responseData(res) {
      return (res.data || res).response;
    },
    responsePage(res) {
      return this.responseData(res) || { data: [], dataCount: 0 };
    },
    formatDate(value) {
      return value ? String(value).slice(0, 10) : '-';
    },
    /**
     * 号次展示：无号次时留空。
     */
    formatSeatNumber(value) {
      const seat = Number(value);
      return seat > 0 ? seat : '';
    },
    /**
     * 无头像时用姓名首字作为默认头像。
     */
    studentNameInitial(name) {
      const text = String(name || '').trim();
      return text ? text.slice(0, 1) : '?';
    },
    formatDateValue(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    /**
     * 解析为本地日期，兼容 yyyy-MM-dd。
     */
    parseLocalDate(value) {
      if (!value) return null;
      if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
      const text = String(value).slice(0, 10);
      const parts = text.split('-').map(Number);
      if (parts.length !== 3 || parts.some((x) => Number.isNaN(x))) return null;
      return new Date(parts[0], parts[1] - 1, parts[2]);
    },
    /**
     * 取所在周周一。
     */
    getWeekMonday(value) {
      const date = this.parseLocalDate(value);
      if (!date) return null;
      const day = (date.getDay() + 6) % 7;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() - day);
    },
    /**
     * 取所在周周日。
     */
    getWeekSunday(value) {
      const monday = this.getWeekMonday(value);
      if (!monday) return null;
      return new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
    },
    /**
     * 默认当前自然周：周一至周日。
     */
    getDefaultWeekRange() {
      const monday = this.getWeekMonday(new Date());
      const sunday = this.getWeekSunday(monday);
      return {
        StartDate: this.formatDateValue(monday),
        EndDate: this.formatDateValue(sunday),
      };
    },
    /**
     * 默认当前自然月。
     */
    getDefaultMonthRange() {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const month = this.formatDateValue(start).slice(0, 7);
      return {
        StartDate: this.formatDateValue(start),
        EndDate: this.formatDateValue(end),
        startMonth: month,
        endMonth: month,
      };
    },
    periodLabel(value) {
      if (value === 'Week') return '按周';
      if (value === 'Month') return '按月';
      if (value === 'DateRange') return '指定日期';
      return value || '-';
    },
    /**
     * 周期类型对应的 Tag 颜色。
     */
    periodTagType(value) {
      if (value === 'Week') return '';
      if (value === 'Month') return 'success';
      if (value === 'DateRange') return 'warning';
      return 'info';
    },
    /**
     * 切换周期类型时重置默认起止。
     */
    onPeriodTypeChange(type) {
      this.startMonth = null;
      this.endMonth = null;
      if (type === 'Month') {
        const month = this.getDefaultMonthRange();
        this.startMonth = month.startMonth;
        this.endMonth = month.endMonth;
        this.competitionForm.StartDate = month.StartDate;
        this.competitionForm.EndDate = month.EndDate;
        return;
      }
      if (type === 'Week') {
        const week = this.getDefaultWeekRange();
        this.competitionForm.StartDate = week.StartDate;
        this.competitionForm.EndDate = week.EndDate;
        return;
      }
      if (!this.competitionForm.StartDate) {
        this.competitionForm.StartDate = this.formatDateValue(new Date());
      }
      if (!this.competitionForm.EndDate) {
        this.competitionForm.EndDate = this.competitionForm.StartDate;
      }
    },
    /**
     * 开始/结束月份映射为竞赛起止日（月初～月末）。
     */
    syncMonthFormDates() {
      if (!this.startMonth || !this.endMonth) {
        this.competitionForm.StartDate = null;
        this.competitionForm.EndDate = null;
        return;
      }
      const startParts = String(this.startMonth).split('-').map(Number);
      const endParts = String(this.endMonth).split('-').map(Number);
      const start = new Date(startParts[0], startParts[1] - 1, 1);
      const end = new Date(endParts[0], endParts[1], 0);
      this.competitionForm.StartDate = this.formatDateValue(start);
      this.competitionForm.EndDate = this.formatDateValue(end);
    },
    /**
     * 编辑回填时同步月份选择。
     */
    syncPeriodFieldsFromForm() {
      this.startMonth = null;
      this.endMonth = null;
      if (this.competitionForm.PeriodType !== 'Month') return;
      const start = this.formatDate(this.competitionForm.StartDate);
      const end = this.formatDate(this.competitionForm.EndDate);
      this.startMonth = start !== '-' ? start.slice(0, 7) : null;
      this.endMonth = end !== '-' ? end.slice(0, 7) : null;
    },
    getOrgType(node) {
      if (!node) return '';
      return String(node.DeptOrgType || node.deptOrgType || '').trim().toLowerCase();
    },
    getDeptId(node) {
      if (!node) return 0;
      return Number(node.value || node.Id || node.id || 0);
    },
    getDeptName(node) {
      if (!node) return '';
      return node.label || node.Name || node.name || '';
    },
    /**
     * 列表查询参数：班级走单班接口，其他节点走下级汇总。
     */
    buildQueryParams(pageSize) {
      const common = {
        name: this.filters.name || undefined,
        periodType: this.filters.periodType || undefined,
        page: pageSize <= 0 ? 1 : this.pagination.page,
        pageSize,
      };
      if (this.isClassNode) {
        return { ...common, departmentId: this.departmentId };
      }
      return { ...common, schoolDepartmentId: this.departmentId };
    },
    treeNodeClick(node) {
      this.treeNode = node;
      this.departmentId = this.getDeptId(node);
      this.className = this.getDeptName(node);
      this.pagination.page = 1;
      this.loadCompetitions();
    },
    handleQuery() {
      if (!this.departmentId) return this.$message.warning('请先选择左侧部门');
      this.pagination.page = 1;
      this.loadCompetitions();
    },
    resetFilters() {
      this.filters = { name: '', periodType: '' };
      this.pagination.page = 1;
      this.loadCompetitions();
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.loadCompetitions();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
      this.loadCompetitions();
    },
    /**
     * 班级节点查本班；学校/校区/年级查下属全部班级竞赛。
     */
    async loadCompetitions() {
      if (!this.departmentId) return;
      this.loading = true;
      try {
        const params = this.buildQueryParams(this.pagination.pageSize);
        const page = this.responsePage(
          this.isClassNode
            ? await getClassGroupCompetitions(params)
            : await getClassGroupCompetitionSummary(params)
        );
        this.competitions = page.data || [];
        this.pagination.total = page.dataCount || 0;
      } finally {
        this.loading = false;
      }
    },
    async openCompetition(row) {
      if (!this.departmentId) return this.$message.warning('请先选择左侧部门');
      this.classPath = [];
      this.classCascaderOptions = [];
      if (row) {
        this.competitionForm = {
          ...row,
          TeacherInfoId: 0,
          DepartmentId: row.DepartmentId,
          DepartmentName: row.DepartmentName || this.className,
          StartDate: this.formatDate(row.StartDate) === '-' ? null : this.formatDate(row.StartDate),
          EndDate: this.formatDate(row.EndDate) === '-' ? null : this.formatDate(row.EndDate),
        };
        this.syncPeriodFieldsFromForm();
      } else {
        this.competitionForm = this.emptyCompetition();
        this.startMonth = null;
        this.endMonth = null;
        if (this.isClassNode) {
          this.competitionForm.DepartmentId = this.departmentId;
          this.competitionForm.DepartmentName = this.className;
        } else {
          await this.loadClassCascaderOptions();
          if (!this.classCascaderOptions.length) {
            return this.$message.warning('当前节点下没有可选班级');
          }
        }
      }
      this.competitionDialog = true;
    },
    /**
     * 点击成员数：打开成员维护弹窗（表格勾选）。
     */
    async openMembers(row) {
      if (!row || !row.Id) return;
      this.memberForm = {
        ...row,
        DepartmentName: row.DepartmentName || this.className || '',
        StartDate: this.formatDate(row.StartDate) === '-' ? null : this.formatDate(row.StartDate),
        EndDate: this.formatDate(row.EndDate) === '-' ? null : this.formatDate(row.EndDate),
      };
      this.memberKeyword = '';
      this.memberStudentIds = [];
      this.students = [];
      this.memberLoading = true;
      this.memberDialog = true;
      try {
        const [ids] = await Promise.all([
          this.fetchCompetitionMemberIds(row.Id),
          this.loadClassStudents(row.DepartmentId),
        ]);
        this.memberStudentIds = ids || [];
      } finally {
        this.memberLoading = false;
      }
    },
    /**
     * 是否已选中该学生。
     */
    isMemberSelected(studentId) {
      const id = Number(studentId || 0);
      return id > 0 && (this.memberStudentIds || []).some((x) => Number(x) === id);
    },
    /**
     * 设置单个学生选中状态。
     */
    setMemberSelected(studentId, checked) {
      const id = Number(studentId || 0);
      if (!id) return;
      const selected = new Set((this.memberStudentIds || []).map((x) => Number(x)));
      if (checked) selected.add(id);
      else selected.delete(id);
      this.memberStudentIds = Array.from(selected);
    },
    /**
     * 点击行切换勾选。
     */
    onMemberRowClick(row, _column, event) {
      const target = event && event.target;
      if (target && target.closest && target.closest('.el-checkbox')) return;
      if (!row) return;
      this.setMemberSelected(row.StudentId, !this.isMemberSelected(row.StudentId));
    },
    /**
     * 表头复选框：全选/取消当前筛选结果。
     */
    toggleSelectAllFiltered(checked) {
      const selected = new Set((this.memberStudentIds || []).map((x) => Number(x)));
      (this.filteredStudents || []).forEach((row) => {
        const id = Number(row.StudentId || 0);
        if (!id) return;
        if (checked) selected.add(id);
        else selected.delete(id);
      });
      this.memberStudentIds = Array.from(selected);
    },
    /**
     * 全选当前筛选结果。
     */
    selectAllMembers() {
      this.toggleSelectAllFiltered(true);
    },
    /**
     * 清空全部已选。
     */
    clearMemberSelection() {
      this.memberStudentIds = [];
    },
    /**
     * 保存竞赛小组成员。
     */
    async saveMembers() {
      if (!this.memberForm || !this.memberForm.Id) return;
      const studentIds = (this.memberStudentIds || [])
        .map((id) => Number(id))
        .filter((id) => id > 0);
      if (!studentIds.length) {
        return this.$message.warning('请至少选择一名成员');
      }
      this.savingMembers = true;
      try {
        const payload = {
          Id: this.memberForm.Id,
          TeacherInfoId: 0,
          DepartmentId: this.memberForm.DepartmentId,
          Name: this.memberForm.Name,
          Description: this.memberForm.Description || '',
          PeriodType: this.memberForm.PeriodType,
          StartDate: this.memberForm.StartDate,
          EndDate: this.memberForm.EndDate,
          Status: this.memberForm.Status == null ? 1 : this.memberForm.Status,
          StudentIds: studentIds,
        };
        const res = await saveClassGroupCompetition(payload);
        const data = res.data || res;
        if (data && data.success === false) {
          return this.$message.error(data.msg || '保存失败');
        }
        this.memberDialog = false;
        this.$message.success('成员已保存');
        await this.loadCompetitions();
      } finally {
        this.savingMembers = false;
      }
    },
    /**
     * 加载当前节点下的校区/学段/年级/班级级联树。
     * 必须走家校教学树（与左侧 DepartmentPane teaching 一致），不能用无范围的 GetSubDepartmentList（会混入内部通讯录）。
     */
    async loadClassCascaderOptions() {
      const activeSchoolId = Number(this.$store.state.activeSchoolId || 0);
      const res = await getTeachingDepartmentTree({
        pid: 0,
        scopeDepartmentId: activeSchoolId,
      });
      const tree = this.responseData(res);
      const roots = Array.isArray(tree) ? tree : (tree ? [tree] : []);
      const current = this.findDepartmentTreeNode(roots, this.departmentId);
      const children = current
        ? (current.children || current.Children || [])
        : [];
      this.classCascaderOptions = this.buildTeachingClassCascader(children);
    },
    /**
     * 在家校树中定位当前选中部门节点。
     */
    findDepartmentTreeNode(nodes, departmentId) {
      const want = Number(departmentId || 0);
      if (!want) return null;
      for (const node of nodes || []) {
        const id = Number(node.value || node.Id || node.id || 0);
        if (id === want) return node;
        const hit = this.findDepartmentTreeNode(node.children || node.Children || [], want);
        if (hit) return hit;
      }
      return null;
    },
    /**
     * 将家校树转为级联选项，仅保留能落到班级的路径；排除教职工等内部节点。
     */
    buildTeachingClassCascader(nodes) {
      const teachingTypes = new Set(['school', 'campus', 'period', 'grade', 'class']);
      const options = [];
      (nodes || []).forEach((item) => {
        const id = Number(item.value || item.Id || item.id || 0);
        if (!id) return;
        const type = String(item.DeptOrgType || item.deptOrgType || '').trim().toLowerCase();
        if (type && !teachingTypes.has(type)) return;
        const label = item.label || item.Name || item.name || String(id);
        if (type === 'class') {
          options.push({ value: id, label });
          return;
        }
        const nested = this.buildTeachingClassCascader(item.children || item.Children || []);
        if (nested.length) {
          options.push({ value: id, label, children: nested });
        }
      });
      return options;
    },
    async onClassPathChange(path) {
      if (!path || !path.length) {
        this.competitionForm.DepartmentId = 0;
        this.competitionForm.DepartmentName = '';
        return;
      }
      this.competitionForm.DepartmentId = Number(path[path.length - 1]);
      const labels = [];
      let options = this.classCascaderOptions;
      path.forEach((id) => {
        const hit = (options || []).find((x) => Number(x.value) === Number(id));
        if (hit) {
          labels.push(hit.label);
          options = hit.children || [];
        }
      });
      this.competitionForm.DepartmentName = labels[labels.length - 1] || '';
    },
    async saveCompetition() {
      if (!this.competitionForm.DepartmentId) {
        return this.$message.warning('请选择班级');
      }
      if (!this.competitionForm.Name || !String(this.competitionForm.Name).trim()) {
        return this.$message.warning('请填写竞赛小组名称');
      }
      if (this.competitionForm.PeriodType === 'Month') {
        this.syncMonthFormDates();
        if (!this.startMonth || !this.endMonth) {
          return this.$message.warning('请选择开始月份和结束月份');
        }
      }
      if (!this.competitionForm.StartDate) {
        if (this.competitionForm.PeriodType === 'Month') return this.$message.warning('请选择开始月份');
        return this.$message.warning('请选择开始日期');
      }
      if (!this.competitionForm.EndDate) {
        if (this.competitionForm.PeriodType === 'Month') return this.$message.warning('请选择结束月份');
        return this.$message.warning('请选择结束日期');
      }
      if (String(this.competitionForm.EndDate) < String(this.competitionForm.StartDate)) {
        return this.$message.warning('结束日期不能早于开始日期');
      }
      const isCreate = !this.competitionForm.Id;
      if (isCreate) {
        const today = this.formatDateValue(new Date());
        if (String(this.competitionForm.EndDate) < today) {
          return this.$message.warning('不能创建已过期竞赛，请将结束日期调整为今天或以后');
        }
      }
      this.saving = true;
      try {
        // 编辑基础信息时保留原成员；新建先落库，再弹表格维护成员。
        const studentIds = this.competitionForm.Id
          ? await this.fetchCompetitionMemberIds(this.competitionForm.Id)
          : [];
        const payload = {
          ...this.competitionForm,
          StudentIds: studentIds,
        };
        const res = await saveClassGroupCompetition(payload);
        const data = res.data || res;
        if (data && data.success === false) {
          return this.$message.error(data.msg || '保存失败');
        }
        const competitionId = Number((data && data.response) || this.competitionForm.Id || 0);
        this.competitionDialog = false;
        this.$message.success('保存成功');
        await this.loadCompetitions();
        if (isCreate && competitionId) {
          const created = (this.competitions || []).find((x) => Number(x.Id) === competitionId) || {
            Id: competitionId,
            DepartmentId: payload.DepartmentId,
            DepartmentName: payload.DepartmentName,
            Name: payload.Name,
            Description: payload.Description,
            PeriodType: payload.PeriodType,
            StartDate: payload.StartDate,
            EndDate: payload.EndDate,
            Status: payload.Status,
          };
          this.openMembers(created);
        }
      } finally {
        this.saving = false;
      }
    },
    async removeCompetition(row) {
      await this.$confirm('确定停用该竞赛小组吗？', '提示');
      await deleteClassGroupCompetition({ competitionId: row.Id });
      this.$message.success('已停用');
      this.loadCompetitions();
    },
    /**
     * 下载后台导出的 Excel。
     */
    downloadExcelBlob(data, fileName) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /**
     * 导出当前节点范围内全部筛选结果（后台接口）。
     */
    async exportExcel() {
      if (!this.departmentId) return this.$message.warning('请先选择左侧部门');
      this.exporting = true;
      try {
        const params = this.buildQueryParams(0);
        const response = await exportClassGroupCompetitions(params);
        if (!response.data) return this.$message.error('导出数据为空');
        const mime = String((response.data && response.data.type) || '');
        if (mime && mime.indexOf('sheet') < 0 && mime.indexOf('octet-stream') < 0) {
          const text = await response.data.text();
          let msg = '导出失败';
          try {
            const json = JSON.parse(text);
            msg = json.msg || json.title || json.detail || msg;
          } catch (e) {
            if (text) msg = text;
          }
          return this.$message.error(msg);
        }
        this.downloadExcelBlob(response.data, `班级小组竞赛_${this.className || '列表'}.xlsx`);
      } catch (e) {
        this.$message.error('导出出错');
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.cgc-admin {
  height: 100%;
}
.cgc-admin /deep/ .el-button.danger,
.cgc-admin /deep/ .el-button.danger span {
  color: #f56c6c;
}
.cgc-admin /deep/ .el-button.danger:hover,
.cgc-admin /deep/ .el-button.danger:hover span {
  color: #f78989;
}
.member-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 12px;
  color: #606266;
  font-size: 13px;
}
.member-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.member-toolbar__search {
  width: 280px;
}
.member-avatar-empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
}
.member-table /deep/ .el-table__row {
  cursor: pointer;
}
.member-toolbar__actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.field-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.field-tip--week > div + div,
.field-tip--month > div + div {
  margin-top: 2px;
}
.tip-em {
  font-weight: 600;
  padding: 0 2px;
}
.tip-em--primary {
  color: #409eff;
}
.tip-em--success {
  color: #67c23a;
}
.tip-em--warning {
  color: #e6a23c;
}
.tip-em--danger {
  color: #f56c6c;
}
</style>

<style>
.cgc-member-dialog {
  margin-top: 8vh !important;
}
.cgc-member-dialog .el-dialog__body {
  padding-top: 12px;
  padding-bottom: 16px;
}
.cgc-member-dialog .el-table__empty-block {
  min-height: 320px;
}
</style>
